import React from 'react';
import PropTypes from 'prop-types';
import { imageStyle } from 'utils/images';
import { SFEntityID } from 'utils/types';
import { Item } from 'semantic-ui-react';
import css from './ConnectionItem.scss';
import ConnectionItemDropdown from './ConnectionItemDropdown';
import { camelCase } from 'lodash';
import { Link } from 'react-router-dom';

import * as routes from "serviceCatalog/routes";

class ConnectionItem extends React.Component {

  render() {
    const { personId, fullName, roles, onlineSchedulingAvailable, email, phoneNumber, title, serviceId } = this.props;
    return (
      <Item className={css['item-container']} id={camelCase("connection " + fullName)}>
        <Link to={routes.toStaffUserInService({ staffUserId: personId, serviceId })} className={css['link']}>
          <div className={css['image']} style={imageStyle(this.props.uuid, this.props.photoAvailable)} />
          <Item.Content>
            <Item.Header className={css['header']}>{fullName}</Item.Header>
            <Item.Meta className={css['meta']}>
              {title ? title : roles.join(', ')}
            </Item.Meta>
          </Item.Content>
        </Link>
        <ConnectionItemDropdown
          personId={personId}
          fullName={fullName}
          onlineSchedulingAvailable={onlineSchedulingAvailable}
          email={email}
          phoneNumber={phoneNumber}
          serviceId={serviceId}
          upward={true}
        />
      </Item>
    );
  }
}

ConnectionItem.propTypes = {
  personId: SFEntityID.isRequired,
  uuid: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  email: PropTypes.string,
  phoneNumber: PropTypes.string,
  roles: PropTypes.array.isRequired,
  onlineSchedulingAvailable: PropTypes.bool,
  photoAvailable: PropTypes.bool,
  title: PropTypes.string,
  serviceId: SFEntityID
};

export default ConnectionItem;
